import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { PusherProvider } from '@/contexts/PusherContext';
import { UnlockKeysDialog } from '@/components/UnlockKeysDialog';
import { clearLoginHintToken } from '@utils/loginHintToken';

export const Route = createFileRoute('/secure/portal')({
  component: PortalLayout,
});

function PortalLayoutInner() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate({ to: '/secure/login' });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // The hint token identifies one patient account for 14 days and lives in
  // module state, which logout does not reset (it is an SPA navigate, not a
  // reload) — on a shared device the next patient's login screen would resolve
  // the previous patient's masked phone/email. Reaching the portal means the
  // token has done its job, and every logout control lives inside this layout,
  // so clearing here bounds it to the session that spent it.
  useEffect(() => {
    if (isAuthenticated) clearLoginHintToken();
  }, [isAuthenticated]);

  // Don't render children until we know user is authenticated
  if (isLoading || !isAuthenticated) {
    return null;
  }

  return (
    <PusherProvider>
      <UnlockKeysDialog />
      <Outlet />
    </PusherProvider>
  );
}

function PortalLayout() {
  return (
    <AuthProvider>
      <PortalLayoutInner />
    </AuthProvider>
  );
}
